export default {
    Metadata: {
        Name: "IsNativeApp",
        Description: "Returns a boolean. True if the app is running as a native app, otherwise False",
        Syntax: "IsNativeApp()",
        Keywords: ['Mobile', 'Device', 'Cordova', 'Native'],
        Author: "DataVoke, Inc.",
    },
    execute() {
        return api.isNativeApp;
    },
};
